import dayjs from 'dayjs'

export const URLS = {
  AUTH_HOME: '/',
  AUTH_TEAM_DAY_OFF_MANAGEMENT: '/teamDayOffManagement',
  AUTH_TEAM_ASSIGNMENT: '/teamAssignment',
  LOGINOIDC: '/signin-oidc',
  LOGOUTOIDC: '/signout-oidc'
}

export const DRAWER_WIDTH = 400

export const TOKEN_KEY = 'carrefour-dex-id-token'

export const FIREBASE_TOKEN_KEY = 'carrefour-dex-firebase-token'
export const FIREBASE_USER = 'carrefour-dex-firebase-user'

export const ROLE_ALL = 'all'

export const PUBLIC_HOLIDAYS_SELECTION_MIN_DATE = dayjs('2023-01-01')
export const PUBLIC_HOLIDAYS_SELECTION_MAX_DATE = dayjs('2030-12-31')

export const SHOP_RECEPTION_ADMIN_MODULE_ID = 5
export const SHOP_RECEPTION_MOBILE_MODULE_ID = 6
export const SHOP_RECEPTION_SUPPLIERS_ADMIN_MODULE_ID = 13
export const SHOP_RECEPTION_SUPPLIERS_MOBILE_MODULE_ID = 14

export const SHOP_RECEPTION_ALL_MODULE_IDS = [
  SHOP_RECEPTION_ADMIN_MODULE_ID,
  SHOP_RECEPTION_MOBILE_MODULE_ID,
  SHOP_RECEPTION_SUPPLIERS_ADMIN_MODULE_ID,
  SHOP_RECEPTION_SUPPLIERS_MOBILE_MODULE_ID,
]
